import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'
import { LocalizedLink } from '@/components/LocalizedLink'

export function HeroSection() {
  const { t } = useTranslation('common')

  return (
    <section className="relative w-full h-[90vh] min-h-[600px] max-h-[960px] overflow-hidden bg-[#2A0E0E]">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="/images/mondo_fiorucci_Mondo-Fiorucci_1440x612-hero-img_DESKTOP.jpg"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#2A0E0E] via-[#2A0E0E]/40 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#2A0E0E]/70 via-transparent to-transparent" />
      </div>

      {/* Grain */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.04] z-10"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`,
        }}
      />

      {/* Content */}
      <div className="relative z-20 h-full flex items-end pb-32 md:pb-36">
        <div className="mx-auto max-w-7xl w-full px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.25, 0.1, 0.25, 1] }}
            className="max-w-2xl"
          >
            <div className="flex items-center gap-4 mb-6">
              <span className="h-px w-10 bg-[#DF631E]" />
              <span className="text-xs font-semibold uppercase tracking-[0.25em] text-[#DF631E]">
                {t('home.hero.slide3.title')}
              </span>
            </div>

            <h1
              className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.05] mb-5"
              style={{ fontFamily: 'Playfair Display, Georgia, serif' }}
            >
              {t('home.hero.slide3.subtitle')}
            </h1>

            <p className="text-base md:text-lg text-white/70 max-w-lg leading-relaxed mb-8">
              {t('home.hero.slide3.description')}
            </p>

            <div className="flex flex-wrap gap-4">
              <LocalizedLink
                to="products"
                className="inline-flex items-center px-7 py-3.5 bg-[#DF631E] text-white text-sm font-semibold tracking-wide uppercase rounded-none hover:bg-[#B85018] transition-colors duration-300"
              >
                {t('home.hero.ctaPrimary')}
              </LocalizedLink>
              <LocalizedLink
                to="about"
                className="inline-flex items-center px-7 py-3.5 border border-white/25 text-white text-sm font-semibold tracking-wide uppercase rounded-none hover:bg-white/10 transition-colors duration-300"
              >
                {t('home.hero.ctaSecondary')}
              </LocalizedLink>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-[#FDF8F3] to-transparent z-20" />
    </section>
  )
}
